import React from 'react';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { callWidgetActivity as CallWidgetActivityView } from 'ui/views/widgets/callWidgetActivity';
import { CallWidgetActivityService } from 'services/callWidgetActivity';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallWidgetActivity } from 'ui/containers/CallWidgetActivity';
 *
 * // render
 * <CallWidgetActivity propName='propValue'/>
 */
export class CallWidgetActivity extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
  
        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.callWidgetActivityService = new CallWidgetActivityService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'CallWidgetActivity.fetchComponentData()' );

        // cancel ongoing request
        this.callWidgetActivityService.cancel();

        // get status and service data
        const { status, data } = await this.callWidgetActivityService.fetchComponentData( {
            url: this.props.widget.url,
            data: this.props.requestPayload
            
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.callWidgetActivityService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallWidgetActivityView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
CallWidgetActivity.displayName = 'CallWidgetActivity';

// set default props
CallWidgetActivity.defaultProps = {};

// prop types
CallWidgetActivity.propTypes = {};
